import { get } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import {
  EMAIL_EXISTS_ERROR,
  GENERIC_ERROR,
  INVALID_EMAIL_ADDRESS_ERROR,
  INVALID_OTP_ERROR,
  INVALID_PASSWORD_ERROR,
  INVALID_PHONE_NUMBER_ERROR,
} from "../../../../../constants";
import "./error-message.module.css";

export const ErrorMessage = ({ response = "", api = "", mode }) => {
  const { emailError, existsError, genericError, otpError, passwordError, phoneError } = useSelector((state) =>
    get(state, ["qt", "config", "pagebuilder-config", "login", "pageSetting"], {})
  );
  const style = {
    400: "error-400",
    401: "error-401",
    409: "error-409",
    500: "error",
    429: "error",
    404: "error",
  };

  const generalError = genericError || GENERIC_ERROR;
  const errorObject = {
    "send-otp-mobile": {
      400: phoneError || INVALID_PHONE_NUMBER_ERROR,
      401: generalError,
      429: generalError,
      500: generalError,
    },
    "send-otp-email": {
      400: emailError || INVALID_EMAIL_ADDRESS_ERROR,
      401: generalError,
      429: generalError,
      500: generalError,
    },
    "login-email": {
      401: passwordError || INVALID_PASSWORD_ERROR,
      500: generalError,
    },
    "login-mobile": {
      401: otpError || INVALID_OTP_ERROR,
      500: generalError,
    },
    "sign-up": {
      400: emailError || INVALID_EMAIL_ADDRESS_ERROR,
      401: otpError || INVALID_OTP_ERROR,
      500: generalError,
      409: existsError || EMAIL_EXISTS_ERROR,
    },
    "reset-password": {
      401: otpError || INVALID_OTP_ERROR,
      500: generalError,
      404: generalError,
    },
    "update-with-otp": {
      401: otpError || INVALID_OTP_ERROR,
      500: generalError,
      400: generalError,
    },
    "email-check": {
      200: existsError || EMAIL_EXISTS_ERROR,
    },
  };
  const errorStyle = style?.[response] || "error";
  const errorMessage = errorObject?.[api]?.[response] || generalError;
  return <div styleName={`${errorStyle} ${mode}`}>{errorMessage}</div>;
};
